<template>
  <div>
    <el-menu  class="el-menu-demo" mode="horizontal" >
      <el-select v-model="dwid" filterable placeholder="请选择">
        <el-option v-for="item in options" :key="item.DWID" :label="item.DWNAME" :value="item.DWID">
        </el-option>
      </el-select>
    </el-menu>
  </div>
</template>
<script>
import { getalldw, getinforxcl, getCaoliao } from '../api/index.js'
export default {
  data() {
    return {
      dwid:"",
      options: [],
    }
  },
  methods:{
    //获得所有单位
    getSYDW(){
      getalldw().then(res=>{
        // console.log(res)
        this.options = res

      })
    }
  },
  mounted(){
    this.getSYDW()
  }
}
</script>
<style></style>
